import React from 'react';

import { Helmet } from 'react-helmet';

import GraphikBold from '../../../static/fonts/Graphik-Bold-Cy-Web.woff2';
import GraphikLight from '../../../static/fonts/Graphik-Light-Cy-Web.woff2';
import GraphikMedium from '../../../static/fonts/Graphik-Medium-Cy-Web.woff2';
import GraphikRegular from '../../../static/fonts/Graphik-Regular-Cy-Web.woff2';
import GraphikRegularItalic from '../../../static/fonts/Graphik-RegularItalic-Cy-Web.woff2';
import GraphikSemiBold from '../../../static/fonts/Graphik-Semibold-Cy-Web.woff2';
import GraphikSemiBoldItalic from '../../../static/fonts/Graphik-SemiboldItalic-Cy-Web.woff2';

import '../../../static/fonts/fonts.css';

const fonts = [
  GraphikBold,
  GraphikLight,
  GraphikMedium,
  GraphikRegular,
  GraphikRegularItalic,
  GraphikSemiBold,
  GraphikSemiBoldItalic
];

const FontLoader = () => (
  <Helmet>
    {
      fonts.map(font => (
        <link
          key={font}
          as="font"
          crossOrigin="anonymous"
          href={font}
          rel="preload"
          type="font/woff2"
        />
      ))
    }
  </Helmet>
);

export { FontLoader };
export default FontLoader;
